import { Tab, TabClasses, Tabs, TabsClasses } from "@mui/material";
import type { TabProps, TabsProps } from "@mui/material";
import { TabContext, TabList, TabPanel, TabPanelClasses } from "@mui/lab";
import type { TabContextProps, TabListProps, TabPanelProps } from "@mui/lab";
import { withDisplayName } from "../../utils/displayName";

const MuiTab = withDisplayName(Tab, "Tab");
const MuiTabs = withDisplayName(Tabs, "Tabs");
const MuiTabContext = withDisplayName(TabContext, "TabContext");
const MuiTabList = withDisplayName(TabList, "TabList");
const MuiTabPanel = withDisplayName(TabPanel, "TabPanel");

export type {
  TabContextProps,
  TabListProps,
  TabPanelProps,
  TabProps,
  TabsProps,
};

export {
  MuiTab as Tab,
  TabClasses,
  MuiTabContext as TabContext,
  MuiTabList as TabList,
  MuiTabPanel as TabPanel,
  TabPanelClasses,
  MuiTabs as Tabs,
  TabsClasses,
};
